var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgScope = function SvgScope(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 111",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0723 83.0419V99.7057H27.7361",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7361 10.8364H11.0723V27.5002",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9275 27.5002V10.8364H83.2637",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2637 99.7057H99.9275V83.0419",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4464 20.1048C80.237 12.6461 75.6452 5.14878 68.1903 3.35901C60.7353 1.56923 53.2403 6.16478 51.4496 13.6235L43.6726 46.0169C41.882 53.4755 46.4738 60.9729 53.9287 62.7627C61.3837 64.5524 68.8787 59.9569 70.6694 52.4982L78.4464 20.1048Z",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 70.0965C102.048 70.0965 108.267 63.8782 108.267 56.2076C108.267 48.537 102.048 42.3188 94.3776 42.3188C86.707 42.3188 80.4888 48.537 80.4888 56.2076C80.4888 63.8782 86.707 70.0965 94.3776 70.0965Z",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5002 108.045C63.1708 108.045 69.3891 101.826 69.3891 94.1558C69.3891 86.4851 63.1708 80.2669 55.5002 80.2669C47.8296 80.2669 41.6113 86.4851 41.6113 94.1558C41.6113 101.826 47.8296 108.045 55.5002 108.045Z",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3978 71.9419C28.601 71.9419 36.0616 64.4812 36.0616 55.278C36.0616 46.0748 28.601 38.6141 19.3978 38.6141C10.1946 38.6141 2.73389 46.0748 2.73389 55.278C2.73389 64.4812 10.1946 71.9419 19.3978 71.9419Z",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9341 84.9844C72.0946 78.6019 78.2412 72.2332 84.4017 65.8507",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scope.e1737c2e.svg";
export { ForwardRef as ReactComponent };